import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <footer>&copy; Copyright Reserved By : Muhammad Umer</footer>
  )
}

export default Footer